import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initSentry } from './utils/sentry';

// Suppress ResizeObserver loop warnings — harmless browser noise that CRA's
// dev overlay treats as fatal. Sentry filters it from reports; this blocks
// the overlay path too by stopping propagation before webpack-dev-server's
// handleError picks it up.
const RESIZE_OBSERVER_MESSAGES = [
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
];

const hideResizeObserverOverlay = () => {
  const overlayIds = [
    'webpack-dev-server-client-overlay',
    'webpack-dev-server-client-overlay-div',
  ];
  overlayIds.forEach((id) => {
    const overlay = document.getElementById(id);
    if (overlay) {
      overlay.style.display = 'none';
    }
  });
};

window.addEventListener('error', (e) => {
  if (e.message && RESIZE_OBSERVER_MESSAGES.some((m) => e.message.includes(m))) {
    e.stopImmediatePropagation();
    e.preventDefault();
    hideResizeObserverOverlay();
  }
}, true);
window.addEventListener('unhandledrejection', (e) => {
  const msg = e.reason?.message || '';
  if (RESIZE_OBSERVER_MESSAGES.some((m) => msg.includes(m))) {
    e.stopImmediatePropagation();
    e.preventDefault();
    hideResizeObserverOverlay();
  }
}, true);

initSentry(process.env.REACT_APP_SENTRY_DSN);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

import('./lib/cache-bust')
  .then(({ installCacheBustWatcher }) => installCacheBustWatcher())
  .catch(() => {});
